import { DynamicField, DynamicSections, Facility, PaymentDetailType } from '@cargos/sprintpay-models';
import moment from 'moment';
import { Detail } from '../details';
import { UserPayments } from '../payment/payment';
import { UserProperties } from './user';

export class ExpeditorsUser implements UserProperties, UserPayments {
    constructor(
        private apis: Record<string, string>,
        public dynamicFields: DynamicField[] = [],
        public dynamicSections: DynamicSections[] = []
    ) {
        const paymentURL = this.apis['payments'];

        this.dynamicSections = [
            {
                id: 1,
                label: 'Payment Details',
                orderNumber: 0,
                emailDomain: null,
            },
            {
                id: 2,
                label: 'Customer Reference',
                orderNumber: 1,
                emailDomain: null,
            },
        ];
        this.dynamicFields = [
            {
                id: 1,
                name: 'eiReferenceFileNumber',
                label: 'File #',
                section: 1,
                fieldType: 'input',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage:
                    'Your own personal reference # so you can remember this payment. For example your file #.',
                providerId: true,
                apiProviderData: `${paymentURL}/glCodes/search/`,
                validations: [
                    {
                        id: 0,
                        name: 'pattern',
                        value: /^[a-zA-Z0-9]{1,10}$/,
                        message: 'Maximum 10 alpha-numeric characters allowed',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 1,
                        name: 'maxlength',
                        value: '255',
                        message: 'Maximum length exceeded (255 characters maximum)',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 2,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your file #.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                id: 2,
                name: 'glCode',
                label: 'GL Code',
                section: 1,
                fieldType: 'dropdown',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                dependencyFieldName: 'eiReferenceFileNumber',
                dependentFieldId: 1,
                dependentFieldDisabled: true,
                validations: [
                    {
                        id: 0,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your file #.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
        ];
    }

    public getPaymentDetails = (payment: PaymentDetailType, facility: Facility, id: string): Detail[] => [
        {
            label: facility.externalLookup
                ? 'File Number'
                : facility.awbFieldLabel === 'AWB'
                  ? 'RELATED BOL / AWB #'
                  : (facility.awbFieldLabel ?? 'N/A'),
            value: payment.hawb ? payment.hawb : 'N/A',
            show: !facility.externalLookup && !id,
        },
        {
            label: 'Payment Type',
            value: payment.paymentType ? payment.paymentType : 'N/A',
            show: true,
        },
        { label: 'Paid To', value: payment.paidTo ? payment.paidTo : 'N/A', show: true },
        {
            label: 'Cargo facility',
            value: facility.name ? facility.name : 'N/A',
            show: true,
        },
        {
            label: 'Amount',
            value: payment.amount ? '$' + payment.amount.toFixed(2) : 'N/A',
            show: true,
        },
    ];

    public getPaymentCustomerReference = (payment: PaymentDetailType, customerReferenceLabel: string = '') => [];

    public getCustomerInformation = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Customer Name',
            value: payment.customer ? payment.customer.name : 'N/A',
            show: true,
        },
        {
            label: 'Notification email',
            value: payment?.notificationEmail ? payment?.notificationEmail : 'N/A',
            show: true,
        },
        {
            label: 'Created Date',
            value: payment?.createdDate ? moment(payment?.createdDate).format('MMM DD, YYYY') : 'N/A',
            show: true,
        },
    ];

    public getCompanyCustomerReference = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Payment Amount',
            value: payment?.externalData?.type ?? 'N/A',
            show: true,
        },
        {
            label: 'Type',
            value: payment?.paymentType ?? 'N/A',
            show: true,
        },
        { label: 'Location', value: payment?.location ?? 'N/A', show: true },
    ];
}
